import {MithrilComponent} from '@bitstillery/mithril'
import {classes} from '@bitstillery/common/lib/utils'
import m from '@bitstillery/mithril'

interface CollectionViewAttrs {
    className?: string
    /** Greys out the CollectionView to indicate it is inactive */
    inactive?: boolean
    mode?: 'grid' | 'table' | 'list'
    size?: 'd' | 's'
    view?: boolean
}

export class CollectionView extends MithrilComponent<CollectionViewAttrs> {
    view(vnode: m.Vnode<CollectionViewAttrs>) {
        return (
            <div
                className={classes(
                    'c-collection-view',
                    'view',
                    `size-${vnode.attrs.size ?? 'd'}`,
                    vnode.attrs.className,
                    vnode.attrs.mode,
                    {
                        inactive: vnode.attrs.inactive,
                    },
                )}
            >
                {vnode.children}
            </div>
        )
    }
}
